import {
    getDisplayValue
} from '../format-display-value';

export function drawChartLocationHeader(detailsContainer, latVal, lonVal) {
    const rndLat = getDisplayValue(latVal, '2dp');
    const rndLon = getDisplayValue(lonVal, '2dp');

    const headerContainer = $(`<div></div>`);
    headerContainer.css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        flexDirection: 'column'
    });

    // Display the coordinates container
    const locationTitle = $(`<h3>` + 
        `Location: ${rndLon}, ${rndLat}` + 
    `</h3>`);

    headerContainer.append(locationTitle);
        
    detailsContainer.append(headerContainer);   
}